// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NCAxMyI+CiAgPGNpcmNsZSBjeD0iNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGMzZCNUMiLz4KICA8Y2lyY2xlIGN4PSIyNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGOUJFNEQiLz4KICA8Y2lyY2xlIGN4PSI0Ny41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiM1NkM0NTMiLz4KPC9zdmc+Cg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Oswald&family=PT+Serif:ital,wght@0,400;0,700;1,400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contenteditor__container{
  position: fixed;
  inset: 0px;
  z-index: 20;
  background-color: black;
}
.image__popup--wrapper h1{
  font-size: 2em;
}
.image__popup--wrapper h2{
  font-size: 2em;
}

.image__popup--wrapper h3{
  font-size: 1.5em;
}
.image__popup--wrapper h4{
  font-size: 1.17em;
}

@media print {
  body {
    margin: 0 !important;
  }
}

.main-container {
  font-family: "Lato";
  width: fit-content;
  /* margin-left: auto;
  margin-right: auto; */
}

.ck-content {
  font-family: "Lato";
  line-height: 1.6;
  word-break: break-word;
}

.editor-container_classic-editor .editor-container__editor {
  min-width: 795px;
  width: 100%;
}

.ck-content h3.category {
  font-family: "Oswald";
  font-size: 20px;
  font-weight: bold;
  color: #555;
  letter-spacing: 10px;
  margin: 0;
  padding: 0;
}

.ck-content h2.document-title {
  font-family: "Oswald";
  font-size: 50px;
  font-weight: bold;
  margin: 0;
  padding: 0;
  border: 0;
}

.ck-content h3.document-subtitle {
  font-family: "Oswald";
  font-size: 20px;
  color: #555;
  margin: 0 0 1em;
  font-weight: bold;
  padding: 0;
}

.ck-content p.info-box {
  --background-size: 30px;
  --background-color: #e91e63;
  padding: 1.2em 2em;
  border: 1px solid var(--background-color);
  background: linear-gradient(
      135deg,
      var(--background-color) 0%,
      var(--background-color) var(--background-size),
      transparent var(--background-size)
    ),
    linear-gradient(
      135deg,
      transparent calc(100% - var(--background-size)),
      var(--background-color) calc(100% - var(--background-size)),
      var(--background-color)
    );
  border-radius: 10px;
  margin: 1.5em 2em;
  box-shadow: 5px 5px 0 #ffe6ef;
}

.ck-content blockquote.side-quote {
  font-family: "Oswald";
  font-style: normal;
  float: right;
  width: 35%;
  position: relative;
  border: 0;
  overflow: visible;
  z-index: 1;
  margin-left: 1em;
}

.ck-content blockquote.side-quote::before {
  content: "“";
  position: absolute;
  top: -37px;
  left: -10px;
  display: block;
  font-size: 200px;
  color: #e7e7e7;
  z-index: -1;
  line-height: 1;
}

.ck-content blockquote.side-quote p {
  font-size: 2em;
  line-height: 1;
}

.ck-content blockquote.side-quote p:last-child:not(:first-child) {
  font-size: 1.3em;
  text-align: right;
  color: #555;
}

.ck-content span.marker {
  background: yellow;
}

.ck-content span.spoiler {
  background: #000;
  color: #000;
}

.ck-content span.spoiler:hover {
  background: #000;
  color: #fff;
}

.ck-content pre.fancy-code {
  border: 0;
  margin-left: 2em;
  margin-right: 2em;
  border-radius: 10px;
}

.ck-content pre.fancy-code::before {
  content: "";
  display: block;
  height: 13px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  margin-bottom: 8px;
  background-repeat: no-repeat;
}

.ck-content pre.fancy-code-dark {
  background: #272822;
  color: #fff;
  box-shadow: 5px 5px 0 #0000001f;
}

.ck-content pre.fancy-code-bright {
  background: #dddfe0;
  color: #000;
  box-shadow: 5px 5px 0 #b3b3b3;
}
`, "",{"version":3,"sources":["webpack://./src/components/ContentEditor/contenteditor.css"],"names":[],"mappings":"AACE;EAAA,eAAyB;EAAzB,UAAyB;EAAzB,WAAyB;EACzB;AADyB;AAIzB;EAAA;AAAiB;AAGjB;EAAA;AAAiB;;AAIjB;EAAA;AAAmB;AAGnB;EAAA;AAAoB;;AAMtB;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB;uBACqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC;;;;;;;;;;;KAWG;EACH,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,mDAA+W;EAC/W,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B","sourcesContent":[".contenteditor__container {\n  @apply fixed inset-0 z-20;\n  background-color: black;\n}\n.image__popup--wrapper h1 {\n  @apply text-[2em];\n}\n.image__popup--wrapper h2 {\n  @apply text-[2em];\n}\n\n.image__popup--wrapper h3 {\n  @apply text-[1.5em];\n}\n.image__popup--wrapper h4 {\n  @apply text-[1.17em];\n}\n\n@import url(\"https://fonts.googleapis.com/css2?family=Oswald&family=PT+Serif:ital,wght@0,400;0,700;1,400&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap\");\n\n@media print {\n  body {\n    margin: 0 !important;\n  }\n}\n\n.main-container {\n  font-family: \"Lato\";\n  width: fit-content;\n  /* margin-left: auto;\n  margin-right: auto; */\n}\n\n.ck-content {\n  font-family: \"Lato\";\n  line-height: 1.6;\n  word-break: break-word;\n}\n\n.editor-container_classic-editor .editor-container__editor {\n  min-width: 795px;\n  width: 100%;\n}\n\n.ck-content h3.category {\n  font-family: \"Oswald\";\n  font-size: 20px;\n  font-weight: bold;\n  color: #555;\n  letter-spacing: 10px;\n  margin: 0;\n  padding: 0;\n}\n\n.ck-content h2.document-title {\n  font-family: \"Oswald\";\n  font-size: 50px;\n  font-weight: bold;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.ck-content h3.document-subtitle {\n  font-family: \"Oswald\";\n  font-size: 20px;\n  color: #555;\n  margin: 0 0 1em;\n  font-weight: bold;\n  padding: 0;\n}\n\n.ck-content p.info-box {\n  --background-size: 30px;\n  --background-color: #e91e63;\n  padding: 1.2em 2em;\n  border: 1px solid var(--background-color);\n  background: linear-gradient(\n      135deg,\n      var(--background-color) 0%,\n      var(--background-color) var(--background-size),\n      transparent var(--background-size)\n    ),\n    linear-gradient(\n      135deg,\n      transparent calc(100% - var(--background-size)),\n      var(--background-color) calc(100% - var(--background-size)),\n      var(--background-color)\n    );\n  border-radius: 10px;\n  margin: 1.5em 2em;\n  box-shadow: 5px 5px 0 #ffe6ef;\n}\n\n.ck-content blockquote.side-quote {\n  font-family: \"Oswald\";\n  font-style: normal;\n  float: right;\n  width: 35%;\n  position: relative;\n  border: 0;\n  overflow: visible;\n  z-index: 1;\n  margin-left: 1em;\n}\n\n.ck-content blockquote.side-quote::before {\n  content: \"“\";\n  position: absolute;\n  top: -37px;\n  left: -10px;\n  display: block;\n  font-size: 200px;\n  color: #e7e7e7;\n  z-index: -1;\n  line-height: 1;\n}\n\n.ck-content blockquote.side-quote p {\n  font-size: 2em;\n  line-height: 1;\n}\n\n.ck-content blockquote.side-quote p:last-child:not(:first-child) {\n  font-size: 1.3em;\n  text-align: right;\n  color: #555;\n}\n\n.ck-content span.marker {\n  background: yellow;\n}\n\n.ck-content span.spoiler {\n  background: #000;\n  color: #000;\n}\n\n.ck-content span.spoiler:hover {\n  background: #000;\n  color: #fff;\n}\n\n.ck-content pre.fancy-code {\n  border: 0;\n  margin-left: 2em;\n  margin-right: 2em;\n  border-radius: 10px;\n}\n\n.ck-content pre.fancy-code::before {\n  content: \"\";\n  display: block;\n  height: 13px;\n  background: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NCAxMyI+CiAgPGNpcmNsZSBjeD0iNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGMzZCNUMiLz4KICA8Y2lyY2xlIGN4PSIyNi41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiNGOUJFNEQiLz4KICA8Y2lyY2xlIGN4PSI0Ny41IiBjeT0iNi41IiByPSI2LjUiIGZpbGw9IiM1NkM0NTMiLz4KPC9zdmc+Cg==);\n  margin-bottom: 8px;\n  background-repeat: no-repeat;\n}\n\n.ck-content pre.fancy-code-dark {\n  background: #272822;\n  color: #fff;\n  box-shadow: 5px 5px 0 #0000001f;\n}\n\n.ck-content pre.fancy-code-bright {\n  background: #dddfe0;\n  color: #000;\n  box-shadow: 5px 5px 0 #b3b3b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
